import { AnimatedComponent, PageTitle } from "@/components/common";
import { RegistrantInformations } from "@/components/Meditators";
import { RegistrantTable } from "@/components/Meditators/RegistrantTable";
import { TableTitles } from "@/constants";
import { useDisclosure } from "@/hooks";
import { useGetAllMeditators } from "@/hooks/query-hooks/useMeditators";
import { Button, Divider, Drawer, Input, Space } from "antd";
import { useState } from "react";
import { Helmet } from 'react-helmet-async';
import { AiOutlineEye, AiOutlineLeft } from "react-icons/ai";
import { WriteNFCDataModal } from "./component/WriteNFCDataModal";

export function NFCWriter() {
	const [keyword, setKeyword] = useState<string | null>(null);
	const { data } = useGetAllMeditators(1, 10, {
		enabled: !keyword,
		refetchOnMount: true,
	});
	const totalMeditators = data?.totalElements || 10;

	const { data: meditatorsData, isLoading: isMeditatorsLoading } =
		useGetAllMeditators(1, totalMeditators, {
			enabled: !!totalMeditators,
			refetchOnMount: true,
		});

	const meditators = meditatorsData
		? keyword !== null
			? meditatorsData?.content?.filter(
					(meditator) =>
						meditator.user.name
							.toLowerCase()
							.includes(keyword.toLowerCase()) ||
						meditator.user.book?.bookNo
							.toLowerCase()
							.includes(keyword.toLowerCase())
			  )
			: meditatorsData?.content
		: [];

	const renderColumnKeys = [
		TableTitles.registrant_name,
		TableTitles.retreat_level,
		TableTitles.registrant_book_id,
		TableTitles.registrant_phone,
		TableTitles.registrant_nrc,
		TableTitles.registrant_address,
		TableTitles.action,
	];

	return (
		<>
			<AnimatedComponent className="p-4 border border-black/10 rounded">
				<Helmet>
					<title>ယောဂီ စာရင်း</title>
				</Helmet>
				<PageTitle className="text-center">ယောဂီ စာရင်း</PageTitle>
				<Divider />
				<div className="space-y-4">
					<Input.Search
						placeholder="စာအုပ်အမှတ် (သို့) အမည် ဖြင့်ရှာရန်"
						allowClear
						size="large"
						className="!w-80"
						onSearch={(value) => setKeyword(value || null)}
						onClear={() => setKeyword(null)}
					/>
					<RegistrantTable
						dataSource={meditators}
						loading={isMeditatorsLoading}
						renderColumnKeys={renderColumnKeys}
						TableActionComponent={TableActionComponent}
						pagination={{
							pageSize: data?.size || 10,
						}}
						hasFilter={{
							level: true,
						}}
						scroll={{
							y: 300,
						}}
					/>
				</div>
			</AnimatedComponent>
		</>
	);
}

const TableActionComponent = ({
	record,
}: {
	record: MeditatorWithMeditationRetreat;
}) => {
	const [openedDrawer, { toggle: toggleDrawer }] = useDisclosure(false);

	return (
		<Space>
			<WriteNFCDataModal user={record.user} />

			<Button type="text" onClick={toggleDrawer}>
				<AiOutlineEye size={16} />
			</Button>
			<Drawer
				open={openedDrawer}
				onClose={toggleDrawer}
				closeIcon={false}
				destroyOnClose
				width={"79vw"}
				classNames={{
					content: "!w-[cal(100% - 320px)]",
				}}
				title={
					<div className="flex items-center justify-between">
						<Button
							shape="round"
							onClick={toggleDrawer}
							type="text"
							size="large"
							icon={<AiOutlineLeft />}
							className="!font-poppins"
						>
							Back
						</Button>
					</div>
				}
			>
				<RegistrantInformations registrant={record.user} />
			</Drawer>
		</Space>
	);
};
